import './VoteContainer.scss';
import { FC } from "react";
import { ContentItem } from "../../GlobalTypes";
import ContentCard from "./ContentCard/ContentCard";

interface Props {
	children: ContentItem[],
	currentVote: ContentItem|null,
	voteClickCallback: Function
}

const VoteContainer: FC<Props> = (props: Props) => {

	const contentCards = props.children.map((child: ContentItem) => {
		return <ContentCard key={child.id} isSelected={child === props.currentVote} item={child}
							clickCallback={props.voteClickCallback}/>
	});

	const currentVote = () => {
		if (props.currentVote !== null) {
			return (
				<div className="current-vote">
					<h3>You've voted for {props.currentVote?.title}</h3>
					<p>To change your vote, select another film below.</p>
				</div>
			);
		}
		return null;
	}

	return (
		<div className="voting-container">
			{currentVote()}
			<div className="vote-cards-container">
				{contentCards}
			</div>
		</div>

	);
}

export default VoteContainer;
